module.exports = __webpack_public_path__ + "img/ic-announcement-hover.c405f78e.svg";